module.exports = __webpack_public_path__ + "static/aktive_fortbewegung_halb-ac16fd52fddb0f0ea7f70c4f960964bb.png";